import "../Css/Header.css";
import HeroSection from "./components/Home/HeroSection";

const Home = () => {
  return (
    <div className="homemain">
      <HeroSection />
    </div>
  );
};

export default Home;
